import React, { useEffect, useMemo, useState, useCallback } from 'react';
import {
  Box,
  Grid,
  Typography,
  MenuItem,
  Select,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  TextField,
  Input,
  InputLabel,
  Paper,
} from '@mui/material';
import {
  IBuscaOpcaoPagamento,
  IOpcaoPagamento,
  IPersonalizacaoOpcoesPagamento
} from 'interfaces/BuscaOpcaoPagamento';
import { getFormattedDate } from 'utils/transform';
import { validationFieldEnums } from 'utils/constants';

interface IOpcoesPersonalizadasProps {
  selectedDate: Date | null;
  handleDateChange: any;
  entrada: string;
  handleEntradaChange: any
  selectOtherOptions: string;
  setSelectOtherOptions: any;
  valorParcela: string;
  setValorParcela: any;
  quantidadeParcela: number;
  setQuantidadeParcela: any;
  handleQuantidadeParcelaChange: any;
  handleValueParcelaChange: any;
  personalizacaoOpcoesPagamento: IPersonalizacaoOpcoesPagamento;
  valuesValid: any;
}
 
const OpcoesPersonalizadas = ({
  selectedDate,
  handleDateChange,
  entrada,
  handleEntradaChange,
  selectOtherOptions,
  setSelectOtherOptions,
  valorParcela,
  setValorParcela,
  quantidadeParcela,
  setQuantidadeParcela,
  handleQuantidadeParcelaChange,
  handleValueParcelaChange,
  personalizacaoOpcoesPagamento,
  valuesValid
}: IOpcoesPersonalizadasProps) => {

  return ( 
    <Box mt={2} mb={3} width="100%">
      <Grid
        container
        direction="row"
        justifyContent="space-around"
        alignItems="center"
      >
        {!!personalizacaoOpcoesPagamento?.escolherDataVencimento && (
          <Paper
            elevation={0}
            style={{
              cursor: 'pointer',
              borderColor: '#D3D3D3',
              borderWidth: 1,
              width: '100%',
              padding: '16px 8px',
            }}
            variant="outlined"
          >
            <Grid
              container
              direction="row"
              justifyContent="space-around"
              alignItems="center"
            >
              <Grid item xs={12} sm={9}>
                Escolha a data do primeiro pagamento
              </Grid>
              <Grid item xs={12} sm={3}>
                <Select
                  style={{ color: 'black' }}
                  value={selectedDate}
                  label={getFormattedDate(selectedDate)}
                  onChange={e =>
                    handleDateChange(e?.target?.value as any)
                  }
                >
                  {personalizacaoOpcoesPagamento?.listaDataVencimento?.map((opt, index) => (
                    <MenuItem key={index} value={opt as any}>
                      {getFormattedDate(opt)}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          </Paper>
        )}
        {personalizacaoOpcoesPagamento?.escolherValorEntrada && (
          <Box mt={2} width="100%">
            <Paper
              elevation={0}
              style={{
                cursor: 'pointer',
                borderColor: '#D3D3D3',
                borderWidth: 1,
                width: '100%',
                padding: '16px 8px',
              }}
              variant="outlined"
            >
              <Grid
                container
                direction="row"
                justifyContent="space-around"
                alignItems="flex-start"
              >
                <Grid item xs={12} sm={8}>
                  Escolha o valor da entrada
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems={'center'}
                    style={{ maxWidth: '100%', marginBottom: 5 }}
                  >
                    <InputLabel
                      style={{
                        display: 'flex',
                        paddingRight: 4,
                        color: 'black',
                        fontSize: 14,
                        maxWidth: '100%',
                      }}
                    >
                      R${' '}
                    </InputLabel>
                    <TextField
                      type="text"
                      name="ValorEntrada"
                      style={{
                        display: 'flex',
                        color: 'black',
                        maxWidth: '70%',
                        padding: '0.1em',
                        margin: '0.1em',
                        textDecoration: 'none',
                        fontSize: 5,
                      }}
                      value={entrada}
                      helperText={!(valuesValid.valorEntrada) && "Entrada inválida"}
                      error={!(valuesValid.valorEntrada)}
                      onChange={e =>
                        handleEntradaChange(e.target.value)
                      }
                    ></TextField>
                  </Box>
                  <Box>
                    <Typography
                      style={{ color: 'green', fontSize: 12 }}
                    >
                      Mínimo R${' '}
                      {!!personalizacaoOpcoesPagamento?.valorEntradaMinima ? (
                        <>
                          {' '}
                          {personalizacaoOpcoesPagamento?.valorEntradaMinima
                            .toFixed(2)
                            .toString()
                            .replace('.', ',')}
                        </>
                      ) : (
                        <>0,00</>
                      )}
                    </Typography>
                    <Typography
                      style={{ color: 'green', fontSize: 12 }}
                    >
                      Máximo R${' '}
                      {!!personalizacaoOpcoesPagamento?.valorEntradaMaxima ? (
                        <>
                          {' '}
                          {personalizacaoOpcoesPagamento?.valorEntradaMaxima
                            .toFixed(2)
                            .toString()
                            .replace('.', ',')}
                        </>
                      ) : (
                        <>0,00</>
                      )}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        )}

        {personalizacaoOpcoesPagamento?.permitePerquisarParcelamento === true && (
          <Box mt={2}>
            <Paper
              elevation={0}
              style={{
                cursor: 'pointer',
                borderColor: '#D3D3D3',
                borderWidth: 1,
                width: '100%',
                padding: '16px 8px',
              }}
              variant="outlined"
            >
              <Grid
                container
                direction="row"
                justifyContent="space-around"
                alignItems="center"
              >
                <Grid item xs={12} sm={8}>
                  <FormControl component="fieldset">
                    <Typography>
                      Selecione outras opções de pagamento
                    </Typography>
                    <RadioGroup
                      row
                      aria-label="other-options"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel
                        value="QuantidadeParcela"
                        control={
                          <Radio
                            checked={
                              selectOtherOptions ===
                              'QuantidadeParcela'
                            }
                            onClick={() => {
                              setValorParcela('');
                              setSelectOtherOptions(
                                'QuantidadeParcela',
                              );
                            }}
                          />
                        }
                        label="Quantidade de parcelas"
                      />
                      <FormControlLabel
                        value="ValorParcela"
                        control={
                          <Radio
                            checked={
                              selectOtherOptions ===
                              'ValorParcela'
                            }
                            onClick={() => {
                              setQuantidadeParcela(0);
                              setSelectOtherOptions(
                                'ValorParcela',
                              );
                            }}
                          />
                        }
                        label="Valor aproximado da parcela"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {' '}
                  {selectOtherOptions === 'ValorParcela' ? (
                    <>
                      <Box
                        display="flex"
                        flexDirection="row"
                        alignItems={'center'}
                        style={{
                          maxWidth: '100%',
                          marginBottom: 5,
                        }}
                      >
                        <InputLabel
                          style={{
                            display: 'flex',
                            paddingRight: 3,
                            color: 'black',
                            fontSize: 14,
                            maxWidth: '100%',
                          }}
                        >
                          R${' '}
                        </InputLabel>
                        <TextField
                          type="text"
                          name="ValorParcela"
                          helperText={!(valuesValid.valorParcela) && 'Entrada Inválida'}
                          error={!(valuesValid.valorParcela)}
                          style={{
                            display: 'flex',
                            color: 'black',
                            maxWidth: '70%',
                            borderRadius: '0.5em',
                            padding: '0.1em',
                            margin: '0.1em',
                            textDecoration: 'none',
                            fontSize: 13,
                          }}
                          value={valorParcela}
                          onChange={e =>
                            handleValueParcelaChange(
                              e.target.value,
                            )
                          }
                        ></TextField>
                      </Box>
                      <Box>
                        <Typography
                          style={{
                            color: 'green',
                            fontSize: 12,
                          }}
                        >
                          {!!personalizacaoOpcoesPagamento?.valorParcelaMinima &&
                            !!personalizacaoOpcoesPagamento?.valorParcelaMaxima && (
                              <>
                                Entre R${' '}
                                {personalizacaoOpcoesPagamento?.valorParcelaMinima
                                  .toString()
                                  .replace('.', ',')}{' '}
                                e R${' '}
                                {personalizacaoOpcoesPagamento?.valorParcelaMaxima
                                  .toString()
                                  .replace('.', ',')}
                              </>
                            )}
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    <>
                      <TextField
                        name="QuantidadeParcela"
                        value={quantidadeParcela}
                        type="number"
                        error={!(valuesValid.quantidadeParcela)}
                        helperText={!(valuesValid.quantidadeParcela) && 'Entrada Inválida'}
                        style={{ color: 'black' }}
                        onChange={e =>
                          handleQuantidadeParcelaChange(
                            e?.target?.value as any,
                          )
                        }
                      />
                      <Box>
                        <Typography
                          style={{
                            color: 'green',
                            fontSize: 12,
                          }}
                        >
                          {!!personalizacaoOpcoesPagamento?.quantidadeParcelaMinima &&
                            !!personalizacaoOpcoesPagamento?.quantidadeParcelaMaxima && (
                              <>
                                Entre{' '}
                                {personalizacaoOpcoesPagamento?.quantidadeParcelaMinima
                                  .toString()
                                  .replace('.', ',')}
                                x e{' '}
                                {personalizacaoOpcoesPagamento?.quantidadeParcelaMaxima
                                  .toString()
                                  .replace('.', ',')}
                                x
                              </>
                            )}
                        </Typography>
                      </Box>
                    </>
                  )}
                </Grid>
              </Grid>
            </Paper>
          </Box>
        )}
      </Grid>
    </Box> 
  );
}
 
export default OpcoesPersonalizadas;